import { ROUTES_LIST_UPDATED_EVENT } from '../lib/routesListEvents'

export function RoutesIndexView() {
  const container = document.querySelector<HTMLElement>('[data-pagination-container]')
  if (!container) {
    return
  }

  function handlePaginationClick(e: Event) {
    const link = (e.target as HTMLElement).closest<HTMLElement>('[data-pagination-link]')
    if (!link) {
      return
    }

    e.preventDefault()
    const page = link.getAttribute('data-page')
    if (!page) {
      return
    }

    fetchPage(parseInt(page, 10))
  }

  function fetchPage(page: number) {
    const currentContainer = document.querySelector<HTMLElement>('[data-pagination-container]')
    if (!currentContainer) {
      return
    }

    const template = currentContainer.getAttribute('data-fragment-url')
    if (!template) {
      return
    }

    const url = template.replace(':page', String(page))

    fetch(url)
      .then(function handleResponse(res) {
        return res.text()
      })
      .then(function handleHtml(html) {
        currentContainer.outerHTML = html
        bindEvents()
        window.dispatchEvent(new CustomEvent(ROUTES_LIST_UPDATED_EVENT))

        const pageUrlTemplate = document
          .querySelector<HTMLElement>('[data-pagination-container]')
          ?.getAttribute('data-page-url')

        if (pageUrlTemplate) {
          const fullPageUrl =
            page === 1
              ? pageUrlTemplate.replace('?page=:page', '')
              : pageUrlTemplate.replace(':page', String(page))
          history.pushState({ routesPage: page }, '', fullPageUrl)
        }

        scrollToRoutesList()
      })
  }

  function scrollToRoutesList() {
    const routesList = document.getElementById('routes-list')
    if (routesList) {
      routesList.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  function bindEvents() {
    const currentContainer = document.querySelector<HTMLElement>('[data-pagination-container]')
    if (currentContainer) {
      currentContainer.addEventListener('click', handlePaginationClick)
    }
  }

  window.addEventListener('popstate', function handlePopState(e: PopStateEvent) {
    if (e.state?.routesPage) {
      fetchPage(e.state.routesPage)
    }
  })

  const initialPage = new URLSearchParams(window.location.search).get('page') || '1'
  history.replaceState({ routesPage: parseInt(initialPage, 10) }, '')

  bindEvents()
}
